import { useMutation } from "@tanstack/react-query";

import { sessionApi } from "@shared/api";

type UseDeleteSessionParams = {
  id: string;
};

export const useDeleteSession = ({ id }: UseDeleteSessionParams) => {
  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: () => sessionApi.deleteApiV1SessionsId({ id }),
  });

  return { deleteSession: mutateAsync, error, isPending };
};
